
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Placement Details</h1>
                </div>
            </div>
        </div>			
    </div>
</section>      
<section class="section-lg chair-msg">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="inner-title">
                    <h5>Details of MOU done under T&P Forum for the Academic Session 21-22</h5>							
                </div>			
                <div class="inner-title">
                    <h5>Purpose of MOU :	</h5>							
                </div> 
                <ul class="list-item">
                    <li>Internships</li>
                    <li>Placements</li>
                    <li>Industrial visits</li>
                    <li>Research / Live projects</li>
                    <li>Guest lectures</li>
                    <li>Short term certified courses</li>
                </ul>
                <div class="table-responsive mt-3"> 
                    <table class="table table-bordered text-center tbl_custom">
                        <thead>
                            <tr >
                                <th>Sr. No.</th>
                                <th>Name of the organisation</th>
                                <th>Name of the resource person</th>
                                <th>Date of MOU</th>
                                <th>Purpose of MOU</th>
                            </tr>
                        </thead>                        
                        <tbody>
                            <tr class="tableizer-firstrow">
                                <td>1</td>
                                <td>Escron enterprises</td>
                                <td>Rohan Soni</td>
                                <td>23/08/2021</td>
                                <td>Internships & Placements</td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Sandeep Dwellers Pvt Ltd</td>
                                <td>Omprakash Tiwari</td>
                                <td>01/09/2021</td>
                                <td>Internships & Placements</td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Eli Global Microfinance Association</td>
                                <td>Devika Madam</td>
                                <td>09/07/2021</td>
                                <td>Internships & Placements</td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>Neeta Consumer Products Pvt Ltd</td>
                                <td>Rahul Shah</td>
                                <td>09/08/2021</td>
                                <td>Internships & Placements</td>
                            </tr>
                            <tr>
                                <td>5</td>
                                <td>Vicco Laboratories</td>
                                <td>Sanket Joshi</td>
                                <td>17/09/2021</td>
                                <td>Internships & Placements, Industrial Visits</td>
                            </tr>
                            <tr>
                                <td>6</td>
                                <td>Insplore Consultantants Pvt Ltd</td>
                                <td>Neha Chabra</td>
                                <td>22/09/2021</td>
                                <td>Internships</td>
                            </tr>
                            <tr>
                                <td>7</td>
                                <td>The Leading Solutions</td>
                                <td>Priyanka Dua Arora</td>
                                <td>21/09/2021</td>
                                <td>Internships</td>
                            </tr>
                            <tr>
                                <td>8</td>
                                <td>Money Vyapar</td>
                                <td>Shivam Gabba</td>
                                <td>15/09/2021</td>
                                <td>STC & Internships</td>
                            </tr>
                            <tr>
                                <td>9</td>
                                <td>Sumeet Synfab Pvt Ltd </td>
                                <td>Sanyam Kankariya</td>
                                <td>07/10/2021</td>
                                <td>Palcements</td>
                            </tr>
                            <tr>
                                <td>10</td>
                                <td>Ashmi Road Carrier Pvt Ltd</td>
                                <td>Pyare Khan</td>
                                <td>04/10/2021</td>
                                <td>Internships & Placements</td>
                            </tr>
                            <tr>
                                <td>11</td>
                                <td>Shri Salasar Agro Processors</td>
                                <td>Mr. Tulsi M. Aswani</td>
                                <td>07/10/2021</td>
                                <td>Industrial visits , internships </td>
                            </tr>
                            <tr>
                                <td>12</td>
                                <td>Confidence Petroleum India Ltd</td>
                                <td>Miss Rohini Daldale</td>
                                <td>08/10/2021</td>
                                <td>Industrial visits, Internships & Placements</td>
                            </tr>
                            <tr>
                                <td>13</td>
                                <td>aXYKno Capital Services Pvt Ltd, Nagpur</td>
                                <td>Mrunali Sharma</td>
                                <td>11/10/2021</td>
                                <td>Internships</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</section>

